import Image from 'next/image';
import noImagePlaceholder from '@/public/images/No-Image-Placeholder.svg';
import styles from './searchResultsHitMobile.module.scss';
import SkuDescription from './skuDescription';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { SearchResultHitProps } from '@/types/other';
import Link from 'next/link';
import { SkuMainImage } from '../utilites/get-sku-main-image';
export default function SearchResultsHitMobile({ hit }: SearchResultHitProps) {
  return (
    <Link href={`/${hit.slug}`} className={`text-decoration-none text-black ${styles.cardHit}`}>
      <>
        <div>
          <SkuMainImage
            alt={hit.name}
            width={50}
            height={50}
            className="object-fit-contain p-1"
            src={hit.mainImageUrl}
          />
        </div>
        <div>
          <div>
            <b style={{ textAlign: 'left' }}>{hit.name}</b>
            <span>
              <SkuDescription
                IncludeVolumeInPercent={false}
                skuBottleSizeInMl={hit.bottleSizeInMl ?? null}
                skuReleaseDate={hit.releaseDate}
                skuVolumeInPercent={hit.volumeInPercent ?? null}
              />
            </span>
          </div>
          <div>
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </div>
      </>
    </Link>
  );
}
